export default __webpack_public_path__ + "static/media/pastel-shades.1cd9b941.png";